import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, ViewContainerRef } from '@angular/core';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
var PetlStartComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlStartComponent, _super);
    function PetlStartComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        _this.isfileDraggedOver = false;
        return _this;
    }
    Object.defineProperty(PetlStartComponent.prototype, "startNumber", {
        get: function () {
            return this.petlService.startingRowNumber;
        },
        set: function (newValue) {
            this.petlService.startingRowNumber = newValue;
        },
        enumerable: true,
        configurable: true
    });
    PetlStartComponent.prototype.fileSelected = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var file;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        file = this.fileSelectedButton.nativeElement.files[0];
                        return [4 /*yield*/, this.petlService.sendFile(file)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlStartComponent.prototype.browseToUploadFile = function () {
        this.fileSelectedButton.nativeElement.click();
        return false;
    };
    PetlStartComponent.prototype.dragEnter = function (ev) {
        ev.preventDefault();
        this.isfileDraggedOver = true;
    };
    PetlStartComponent.prototype.dragOver = function (ev) {
        ev.preventDefault();
        this.isfileDraggedOver = true;
    };
    PetlStartComponent.prototype.dragLeave = function (ev) {
        ev.preventDefault();
        this.isfileDraggedOver = false;
    };
    PetlStartComponent.prototype.drop = function (ev) {
        this.service.processFileDrop(ev);
        this.isfileDraggedOver = false;
    };
    return PetlStartComponent;
}(PetlBaseComponent));
export { PetlStartComponent };
